import { render, staticRenderFns } from "./view-asset-history.vue?vue&type=template&id=818f6dca&"
import script from "./view-asset-history.vue?vue&type=script&lang=ts&"
export * from "./view-asset-history.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports